import "./AreaDetailView.css"
import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import LoadingSpinner from "../../../../../sharedComponents/LoadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import BackButton from "../../../../../sharedComponents/backButton/BackButton";
import PrimaryButton from "../../../../../sharedComponents/primaryButton/PrimaryButton";

function AreaDetailView(){

    const [isLoading, setIsLoading] = useState(true);
    const [areaEmployees, setAreaEmployees] = useState(null);
    const [areaName, setAreaName] = useState("");
    const [employees, setEmployees] = useState([]);


    useEffect(() => {
        getAreas();
    }, [])

    function getAreas(){
        axios.get('employee/getActive').then(results => 
            setEmployees(results.data)
        )

        axios.get('area').then(results => {
            sessionStorage.setItem("area-id", new URLSearchParams(window.location.search).get("id"));

            const thisArea = results.data.find((element) => element.id === new URLSearchParams(window.location.search).get("id"))
            setAreaEmployees(thisArea.assigned_employee_ids);
            setAreaName(thisArea.name);
            setIsLoading(false);            
        })
    }

    function generateAssignedEmployees() {
        if (areaEmployees.length === 0) {
            return <p>Keine Mitarbeiter zugewiesen.</p>
        }

        return areaEmployees.map((id) => {
            const employee = employees.find(emp => emp.id === id);
            if (!employee) return null;
            
            return (
                <ListItem key={id}>
                    <ListItemAvatar>
                        <Avatar>
                            <PermIdentityIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={`${employee.first_name} ${employee.last_name}`} />
                </ListItem>
            );
        }).filter(Boolean); // Remove null entries if some IDs don't match
    }

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            )
            : (
                <div className="area-detailview-container">
                    <Link to={"/home/settings/bereiche"}><BackButton /></Link>
                    <h3>{areaName}</h3>
                    <div className="area-detailview-employees">
                        <Link to={"assignment"}><PrimaryButton text="Zuweisung ändern"/></Link>
                        <h4>Zugewiesene Mitarbeiter</h4>
                        <List>
                            {generateAssignedEmployees()}
                        </List>
                    </div>
                </div>
            )
            }
        </>
    )
}

export default AreaDetailView;